import React, { useState } from 'react';
import { Button, Modal } from 'ui/atoms';

import ImageFailure from './image-failure';
import './conversation-response-image.css';

const ConversationResponseImage = ({ src }) => {
  const [openImage, setOpenImage] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="conversation-response-image-row">
      <Button
        onClick={() => setOpenImage(true)}
        className="image-button"
        role="button"
        aria-label="full-size-image"
      >
        {!imageError && (
          <img
            src={src}
            alt="Response"
            onError={() => setImageError(true)}
            onLoad={() => setImageError(false)}
          />
        )}
        {imageError && <ImageFailure />}
      </Button>
      <Modal
        open={openImage}
        title={''}
        footer={[]}
        className="conversation-response-image-modal"
        onCancel={() => {
          setOpenImage(false);
        }}
      >
        <img className="full-size" src={src} alt="Response" />
      </Modal>
    </div>
  );
};

export default ConversationResponseImage;
